export const getBannerURL = `/portal-banner/banner/index`;
